export default "__VITE_ASSET__BsP4G_ZP__"